import React from 'react';
import NtsResult_01 from './ntsResults/NtsResult_01';
import NtsResult_02 from './ntsResults/NtsResult_02';
import NtsResult_03 from './ntsResults/NtsResult_03';
import NtsResult_04 from './ntsResults/NtsResult_04';
import NtsResult_05 from './ntsResults/NtsResult_05';
import NtsResult_06 from './ntsResults/NtsResult_06';
import NtsResult_07 from './ntsResults/NtsResult_07';
import NtsResult_08 from './ntsResults/NtsResult_08';
import NtsResult_09 from './ntsResults/NtsResult_09';

const NationalTaxData = ({ selected, monthlyData }) => {
  const render = () => {
    if (selected === '1') {
      //보험료
      return <NtsResult_01 />;
    } else if (selected === '2') {
      //의료비
      return <NtsResult_02 />;
    } else if (selected === '3') {
      //교육비
      return <NtsResult_03 />;
    } else if (selected === '4') {
      //기부금
      return <NtsResult_04 />;
    } else if (selected === '5') {
      //신용카드
      return <NtsResult_05 />;
    } else if (selected === '6') {
      //주택자금
      return <NtsResult_06 />;
    } else if (selected === '7') {
      //기타
      return <NtsResult_07 />;
    } else if (selected === '8') {
      //건강보험료
      return <NtsResult_08 />;
    } else if (selected === '9') {
      //국민연금
      return <NtsResult_09 />;
    }
  };

  return <div className="nationalTaxTable">{render()}</div>;
};

export default NationalTaxData;
